<template>
  <div class="slim-mainpanel">
    <div class="container">
      <div class="slim-pageheader">
        <ol class="breadcrumb slim-breadcrumb">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item"><a href="#">Utilitários</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            Indicadores Semanais
          </li>
        </ol>
        <h6 class="slim-pagetitle">Indicadores Semanais</h6>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="flex ai-c jc-sb">
            <h2>Preview</h2>
			<div class="flex fgap1">
				<button
					type="button"
					class="btn btn-primary"
					:disabled="loading"
					@click="loadManagerialReport"
				>
					{{ 'Buscar Dados' }}
				</button>
				<button class="btn btn-success" @click.prevent="generatePDF">
					Exportar PDF
				</button>
			</div>
          </div>
        </div>
		<div v-if="managerial" class="d-flex justify-content-center">
			<vue-html2pdf
			:show-layout="false"
			:float-layout="false"
			:preview-modal="true"
			:enable-download="false"
			:filename="'indicadores_managerial'"
			pdf-orientation="portrait"
			:pdf-quality="2"
			:manual-pagination="true"
			pdf-content-width="1280px"
			ref="html2Pdf"
			:html-to-pdf-options="pdfOptions"
			>
			<section slot="pdf-content">
				<div ref="indicadoresPdfWrap" class="indicadores-pdf-wrap">
					<indicadores-report ref="indicadoresReport" :managerial="managerial" />
				</div>
			</section>
			</vue-html2pdf>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import config from '@/config.js';
import VueHtml2pdf from 'vue-html2pdf';
import IndicadoresReport from '@/components/IndicadoresManagerial/IndicadoresReport.vue';

export default {
  name: 'IndicadoresManagerial',
  components: {
    VueHtml2pdf,
    IndicadoresReport,
  },
  data() {
    return {
      loading: false,
	  managerial: {},
      pdfOptions: {
        margin: 0,
        filename: 'indicadores_managerial.pdf',
        // Evita inserção de padding/quebras pelo plugin (modo padrão css+legacy).
        pagebreak: { mode: [] },
        image: { type: 'jpeg', quality: 0.9 },
        html2canvas: {
          dpi: 192,
          width: 1280,
          scale: 1.5,
          useCORS: true,
        },
        jsPDF: {
          compress: true,
          unit: 'px',
          // Altura ajustada em generatePDF: [1280, 720] força uma “página” por fatia de 720px
          // e o relatório tem vários slides empilhados → várias páginas no PDF.
          format: [1280, 720],
        },
      },
    };
  },
  methods: {
    async loadManagerialReport() {
		this.$store.commit('setLoading', {
			show: true,
			label: 'Carregando...',
			description: 'Carregando relatório.',
		});
      try {
        const response = await Axios.get(`${config.env.API_DEFAULT.host}/process/import/report/managerial`);
		this.managerial = response.data.data;
      } catch (err) {
		console.error(err);
      } finally {
        this.$store.commit('setLoading', {
          show: false,
        });
      }
    },
    clearManagerialPdfLoading() {
      this.$store.commit('setLoading', {
        show: false,
      });
    },
    async generatePDF() {
      this.$store.commit('setLoading', {
        show: true,
        label: 'Carregando...',
        description: 'Gerando PDF.',
      });
      await this.$nextTick();
      const wrap = this.$refs.indicadoresPdfWrap;
      const contentHeightPx = wrap ? Math.ceil(wrap.scrollHeight) : 720;
      this.$set(this.pdfOptions.jsPDF, 'format', [
        1280,
        Math.max(contentHeightPx, 720),
      ]);

      const html2Pdf = this.$refs.html2Pdf;
      if (!html2Pdf) {
        this.clearManagerialPdfLoading();
        return;
      }
      // Não chamar closePreview() antes de gerar: pode afetar layout/DOM e o html2pdf passar a quebrar em várias páginas.
      // hasDownloaded do pacote é pouco confiável; fechamos loading quando pdfFile mudar para um novo blob desta geração.
      const pdfFileBefore = html2Pdf.pdfFile;
      const unwatch = this.$watch(
        () => this.$refs.html2Pdf && this.$refs.html2Pdf.pdfFile,
        (pdfFile) => {
          if (pdfFile && pdfFile !== pdfFileBefore) {
            this.clearManagerialPdfLoading();
            unwatch();
          }
        },
      );
      html2Pdf.generatePdf();
    },
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.loadManagerialReport();
    });
  },
};
</script>

<style scoped>
.indicadores-pdf-wrap {
  width: 1280px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
